import * as Sentry from '@sentry/react';

export const throwOnError = async <T = unknown>(response: Response) => {
  if (response.redirected) {
    window.location.href = response.url;
    throw 'Redirected due to authorization';
  }

  if (response.status === 204) {
    return Promise.resolve(undefined as T);
  }

  if (response.ok) {
    return response.json() as Promise<T>;
  }

  if (response.status === 504) {
    Sentry.withScope((scope) => {
      scope.setLevel(Sentry.Severity.Warning);
      Sentry.setTag('endpoint', new URL(response.url).pathname);
      Sentry.captureMessage('504 Gateway Timeout');
    });
    throw 'Gateway Timeout';
  }

  if (response.status === 502) {
    Sentry.withScope((scope) => {
      scope.setLevel(Sentry.Severity.Warning);
      Sentry.setTag('endpoint', new URL(response.url).pathname);
      Sentry.captureMessage('502 Bad Gateway');
    });
    throw 'Bad Gateway';
  }

  if (response.status >= 500 && response.status < 600) {
    const text = await response.text();
    const errorMessage = text || 'Server overload or unexpected error';

    Sentry.withScope((scope) => {
      scope.setLevel(Sentry.Severity.Error);
      scope.setTag('endpoint', new URL(response.url).pathname);
      Sentry.captureMessage(errorMessage);
    });

    throw 'Server Error';
  }

  throw response.json();
};

export const rows = <T>(resp: { rows?: T[] }) => resp.rows ?? [];
